<div class="user-agent" *ngIf="userAgent?.os">
  <div class="subgrid">
    <div class="subgrid-icon">
      <a target="_blank" [href]="userAgent.os.url">
        <img [src]="userAgent.os.icon">
      </a>
    </div>
    <p class="subgrid-title">{{ userAgent.os.name }} ({{ userAgent.os.family }})</p>
    <p class="subgrid-subtitle">{{ userAgent.os.family_vendor }}</p>
  </div>

  <div class="browser">
    <p class="browser-title">{{ userAgent.browser.name }} ({{ userAgent.browser.version_major }})</p>
    <p class="browser-subtitle">{{ userAgent.browser.version }}</p>
  </div>

  <div class="subgrid">
    <div class="subgrid-icon">
      <mat-icon>{{ userAgent.device.is_mobile_device ? 'phone_iphone' : 'monitor' }}</mat-icon>
    </div>
    <p class="subgrid-title uppercase">{{ userAgent.device.type }}</p>
    <p class="subgrid-subtitle">{{ userAgent.device.brand ? userAgent.device.brand + ' ' + userAgent.device.name : 'Marca não informada' }}</p>
  </div>
</div>
